<template>
    <div class="login-wrap container">
        <div class="content flexCenter">
            <el-image class="logo" :src="require('@/assets/images/ibayPayLogo.png')"/>
            <div class="ms-login">
                <h1 class="platform-name">
                    <div style="float: left;height: 60px">{{isLanguage==='English'?'iBaypay Login':'贝角直通车登陆'}}</div>
                    <div class="switchLanguage">
                        <el-select v-model="switchLanguage" @change="switchChange">
                            <el-option label="中文" value="Chinese"></el-option>
                            <el-option label="English" value="English"></el-option>
                        </el-select>
                    </div>
                </h1>
                <el-form :model="loginForm" :rules="rules" ref="loginForm">
                    <el-form-item prop="accountId">
                        <el-input
                                v-model="loginForm.accountId"
                                type="text"
                                :placeholder="isLanguage==='English'?'Please enter your account number':'请输入账号'"
                                prefix-icon="iconfont iconuser2">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                                @keyup.enter.native="logIn"
                                v-model="loginForm.password"
                                ref="password"
                                autocomplete="new-password"
                                :type="passwordType"
                                :maxlength="18"
                                :placeholder="isLanguage==='English'?'Please input a password':'请输入密码'"
                                prefix-icon="iconfont iconlock"
                        ></el-input>
                        <span class="show-pwd cursor-pointer" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'nodisplay' : 'display'"/>
              </span>
                    </el-form-item>
                    <p class="cursor-pointer forget-pass textGreen">
                        <router-link to="/login/forgot">{{isLanguage==='English'?'Forgot your password?':'忘记密码？'}}</router-link>
                    </p>

                    <el-form-item prop="text" v-if="!!qrcodeImg">
                        <el-input :placeholder="isLanguage==='English'?'Graphic verification code':'图形验证码'" :maxlength="4" v-model="ruleForm.text"></el-input>
                        <span class="send-qrcode img-qrcode" @click="getImgQrcode()">
              <img :src="'data:image/jpeg;base64,'+ qrcodeImg" alt="">
            </span>
                    </el-form-item>

                    <div class="login-btn">
                        <el-button class="login-button successBtn" @click="logIn" :loading="loading">{{isLanguage==='English'?'Confirm Login':'确认登录'}}</el-button>
                    </div>
                    <p style="font-size:12px;line-height:30px;color:red;">{{errorMsg}}</p>
                </el-form>
            </div>
            <div class="to-register">{{isLanguage==='English'?"Don't have an account yet? Please first":'还没有账号？请先'}}
                <router-link to="/register">
                    <span class="textGreen register cursor-pointer">{{isLanguage==='English'?'register':'注册'}}</span>
                </router-link>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import {UserService} from '@/api'
    import {checkPhone} from '@/utils/common'
    import Footer from '@/components/Footer'
    import { getLanguage } from '@/utils/auth'
    import {checkEmail} from "../../utils/common";
    export default {
        components: {Footer},
        data() {
            return {
                passwordType: 'password',
                redirect: undefined,
                loginForm: {},
                errorMsg: "",
                rules: {
                    accountId: [
                        {required: true,message: "Please input a account", trigger: "blur"},
                    ],
                    password: [
                        {required: true, message: "Please input a password", trigger: "blur"},
                    ],
                },
                loading: false,
                qrcodeImg: "",
                switchLanguage: '',
                isLanguage:getLanguage()
            }
        },
        watch: {
            $route: {
                handler: function (route) {
                    // this.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        computed: {},
        created() {
            this.switchLanguage=window.sessionStorage.getItem('language')?window.sessionStorage.getItem('language'):'English'
        },
        methods: {
            showPwd() {
                if (this.passwordType === 'password') {
                    this.passwordType = ''
                } else {
                    this.passwordType = 'password'
                }
                this.$nextTick(() => {
                    this.$refs.password.focus()
                })
            },
            logIn() {
                this.$refs['loginForm'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$store.dispatch('user/login', this.loginForm).then(res => {
                            if (res.status) {
                                this.$router.push('/')
                                this.$store.dispatch('app/getCommonData')
                                this.$router.go(0)
                            }
                            this.loading = false
                        }).catch((error) => {
                            this.loading = false
                        })
                        setTimeout(() => {
                            this.loading = false
                        }, 6000)
                    } else {
                        this.$message.error('Please fill in the account password')
                    }
                })
            },
            switchChange() {
                window.sessionStorage.setItem('language', this.switchLanguage)
                this.$router.go(0)
            },
        },
    };
</script>

<style lang="scss">
    .login-wrap {
        width: 100vw;
        min-height: 100vh;
        background: rgba(243, 244, 246, 1);

        .content {
            min-height: calc(100vh - 60px);
            flex-direction: column;
            width: 400px;
            margin: 0 auto;

            .logo {
                width: 180px;
                margin-bottom: 20px;
                align-self: flex-start;
                margin-left: 30px;
            }

            .ms-login {
                width: 400px;
                background: rgba(255, 255, 255, 1);
                border-radius: 20px;
                padding: 30px;

                .platform-name {
                    font-size: 18px;
                    font-weight: 600;
                    color: rgba(19, 47, 98, 1);
                    line-height: 40px;
                    margin-bottom: 24px;
                }

                .el-form-item {
                    .el-input {
                        .el-input__inner {
                            height: 48px;
                            padding-left: 46px;
                        }

                        .iconfont {
                            font-size: 24px !important;
                        }
                    }

                    .show-pwd {
                        color: #C0C4CC;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        right: 20px;
                        font-size: 20px;
                    }
                }

                .forget-pass {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 24px;
                    text-align: right;
                    margin: 16px 0;
                }

                .login-button {
                    font-size: 14px;
                    font-weight: 600;
                    color: rgba(255, 255, 255, 1);
                    line-height: 24px;
                    width: 100%;
                    height: 48px;
                    padding: 12px 0;
                }
            }

            .to-register {
                margin-top: 20px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(128, 130, 147, 1);
                line-height: 40px;
                text-align: center;
            }
        }

        .switchLanguage {
            float: right;
            width: 100px;

            input {
                font-size: 10px;
            }
        }
    }
</style>
